<template>
  <am2-item-multiselect
    to="card-sub-details"
    :items="campaigns"
    @select="handleSelect"
    :defaultValue="defaultValue"
    :data-test-id="dataTestId"
    item-label="campaigns"
    @updateSearchText="updateSearchText"
  />
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'CampaignMultiselect',

    props: {
      defaultValue: { // Value equals to campaignOid
        type: Array,
        default: null,
      },
      dataTestId: {
        type: String,
        default: null,
      }
    },

    data() {
      return {
        campaigns: [],
        searchString: null,
      };
    },

    mounted() {
      this.loadCampaigns();
    },

    computed: {
      ...mapState({
        auth: state => state.auth,
      }),
    },

    watch: {
      searchString() {
        this.loadCampaigns()
      }
    },

    methods: {
      handleSelect(item) {
        this.$emit('select', item);
      },

      updateSearchText(text) {
        this.searchString = text
      },

      async loadCampaigns() {
        const { promoterOid } = this.auth.account;
        try {
          const data = await this.$api.campaign.search(promoterOid, {
            top: 50,
            skip: 0,
            orderby: 'endDate desc',
            searchString: this.searchString,
          });

          this.campaigns = data.map( item => {
            return {
              value: item.oid,
              name: item.name,
            }
          });
        } catch (error) {
          this.$arNotification.push({ type: 'error', message: `Something went wrong when searching for the campaign.` })
          console.error('Failed CAMPAIGN search, with error:', error);
        }
      },
    }

  };
</script>
